import(/* webpackMode: "eager" */ "/codebuild/output/src2964855539/src/apps/junonkuji/src/app/error.tsx");
